"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Lead = void 0;

var Lead =
/** @class */
function () {
  function Lead() {}

  Lead.prototype.LeadTemperatureType = function () {
    return [{
      slug: 'not-set',
      name: 'Not Set',
      description: null,
      isCold: false,
      isWarm: false,
      isHot: false,
      isNotSet: true
    }, {
      slug: 'cold',
      name: 'Cold',
      description: null,
      isCold: true,
      isWarm: false,
      isHot: false,
      isNotSet: false
    }, {
      slug: 'warm',
      name: 'Warm',
      description: null,
      isCold: false,
      isWarm: true,
      isHot: false,
      isNotSet: false
    }, {
      slug: 'hot',
      name: 'Hot',
      description: null,
      isCold: false,
      isWarm: false,
      isHot: true,
      isNotSet: false
    }];
  };

  return Lead;
}();

exports.Lead = Lead;